import 'css-chunksrc/client/common/scrollingText/styles.scss';export default {
  "scrollingText": "_scrollingText_f3kd8_1",
  "slider": "_slider_f3kd8_6"
};